import React, { useState } from 'react';

import DragAndDropFileArea from '../DragAndDropFileArea';
import Loader from '../Loader';

type Props = {
  onLoad: (file: File) => Promise<void>;
  className?: string;
};

const MAX_FILE_SIZE_FOR_WRITABLE_STREAM = 2 * 1000 * 1000 * 1000; // 2 GB in bytes

const FileUploader = ({ onLoad, className }: Props): JSX.Element | null => {
  const [isLoading, setIsLoading] = useState(false);
  const [fileLoaded, setFileLoaded] = useState(false);

  const handleStartUpload = async (file: File): Promise<void> => {
    if (file) {
      try {
        if (file.size > MAX_FILE_SIZE_FOR_WRITABLE_STREAM) {
          setFileLoaded(true);
          await onLoad(file);
        } else {
          setIsLoading(true);
          const fileReader = new FileReader();

          fileReader.onload = async (): Promise<void> => {
            if (fileReader.readyState === FileReader.DONE) {
              setIsLoading(false);
              setFileLoaded(true);
              await onLoad(file);
            }
          };

          fileReader.onerror = (error): void => {
            console.error('FileReader error:', error);
            setIsLoading(false);
            alert('An error occurred while reading the file.');
          };

          fileReader.readAsDataURL(file);
        }
      } catch (error) {
        console.error('Upload failed:', error);
        setIsLoading(false);
        alert('Failed to upload the file. Please ensure the file is not in use by another program.');
      }
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  if (fileLoaded) {
    return null;
  }

  return <DragAndDropFileArea className={className} handleStartUploadFile={handleStartUpload} />;
};

export default FileUploader;
